// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a4c31b81","263":"a5b2be23","305":"49b629d9","315":"33d40def","361":"1b276c10","498":"fe17e33c","703":"f6a59e30","779":"d3d6937b","787":"ce10c7e9","875":"b5111163"}[chunkId] + ".chunk.js";
};